import styled from 'styled-components';

export const BonusDepositPanelMobileHeaderStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    label {
        margin-bottom: 0;
    }
`;

export const BonusDepositPanelMobileContainerStyled = styled.div`
    border-radius: 16px;
    background: var(--color-neutral-10);
    height: 61px;
    overflow: hidden;
    transition: height 300ms ease;
    margin-top: 8px;
    
    &.bonus-applied {
        height: 107px;
    }
`;

export const BonusDepositPanelMobileContentStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: linear-gradient(270.98deg, rgba(129, 146, 228, 0.33) 1.23%, rgba(129, 146, 228, 0.15) 100%);
    border-radius: 16px;
    
    &.bonus-applied {
        background: linear-gradient(270.98deg, rgba(254, 250, 123, 0.4) 1.23%, rgba(255, 227, 95, 0.2) 100%);
    }
    
    label {
        font-size: 16px;
        font-weight: 400;
        color: var(--color-white-95);
        margin-left: 16px;
    }
`;

export const BonusDepositPanelMobileTotalAmountStyled = styled.div`
    padding: 10px 12px 12px;
    display: flex;
    justify-content: space-between;
    
    .label {
        color: var(--color-white-60);
        font-size: 14px;
    }
    
    .amount {
        font-size: 16px;
        color: var(--color-white-95);
        font-weight: 600;
    }
`;

export const BonusDepositPanelMobileInfoWrapperStyled = styled.div`
    padding: 8px;
`;

export const BonusDepositPanelMobileTermsHeaderStyled = styled.div`
    padding: 24px 16px 16px;
    display: flex;
`;

export const BonusDepositPanelMobileTermsCloseStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    
    svg {
        fill: var(--color-white-60);
    }
`;

export const BonusDepositPanelMobileTermsTitleStyled = styled.div`
    display: flex;
    align-items: center;
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    color: var(--color-white-60);
`;

export const BonusDepositPanelMobileTermsContentStyled = styled.div`
    padding: 12px 16px;
    color: var(--color-white-60);
    font-size: 16px;
    font-weight: 400;
`;
